import { axiosInstanceConversationalEngine, axiosInstanceWebsite } from "../../instance";
import { AxiosResponse } from "../../interface";
import { postGenerateComplementaryProductInterface, ProductRecommendation, UploadFileToS3Data } from "./generateCopysAxioxinterface";
// import { FormDataProduct } from "../../../components/forms/FormWebsiteConfiguration/FormWebsiteConfigurationInterface";

/**
 * @deprecated Legacy AI builder creation path.
 * Current funnel onboarding should use `postBulkFunnels` from `services/funnels`.
 */
export const postCopys = async (data: any) => {
  data.productDescription = data.productDetails;
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    "/websites",
    data
  );
  
  return response.data;
};

export const getLastCopyByUserId = async (
  userId: string,
  websiteUuid: string
) => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/websites/${websiteUuid}`,
    {
      headers: {
        "Content-Type": "application/json",
        // "owner-id": userId,
      },
    }
  );
  return response.data;
};

// export const postUploadFileToS3 = async (data: UploadFileToS3Data) => {
//   const formData = new FormData();

//   formData.append("userId", data.userId);
//   formData.append("websiteId", data.websiteId);
//   formData.append("index", data.html);
//   formData.append("css", data.css);
//   formData.append("js", data.js);
//   formData.append("upSell", data.upSell);
//   formData.append("downSell", data.downSell);
//   formData.append("thankYou", data.thankYou);
//   formData.append("content", data.content);

//   const response: AxiosResponse = await axiosInstance.post(
//     "/s3-bucket/upload-file-to-s3",
//     formData,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     }
//   );
//   return response.data;
// };

// Tamaño de página del listado de embudos. Debe coincidir con el tope que el
// backend permite por request (coerceAtMost(100) en WebsiteSummaryReadRepository).
export const FUNNELS_SUMMARY_PAGE_SIZE = 100;
// Guarda anti-loop: nunca recorreríamos más de esto (50k embudos) aunque el
// backend devolviera páginas llenas ignorando el offset.
const FUNNELS_SUMMARY_MAX_PAGES = 500;

// El listado de embudos de una cuenta puede tener cientos de embudos. Antes se
// pedía sin `limit`, así que el backend traía TODOS de una sola vez y ese request
// se pasaba del timeout de axios (60s) → "No pudimos cargar tus embudos". Ahora se
// pide en páginas acotadas y se ensambla la lista completa (WebsitesTable ya pagina
// y busca client-side sobre ella, así que el contrato de "lista completa" se mantiene).
export const getListOfFunnels = async () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- filas crudas del summary (mismo shape que consumía la versión previa)
  const all: any[] = [];
  let offset = 0;
  for (let page = 0; page < FUNNELS_SUMMARY_MAX_PAGES; page += 1) {
    const response: AxiosResponse = await axiosInstanceWebsite.get(`/websites/summary`, {
      params: {
        limit: FUNNELS_SUMMARY_PAGE_SIZE,
        offset,
      },
      headers: {
        "Content-Type": "application/json",
        // "owner-id": userId,
      },
    });
    const rows = Array.isArray(response.data) ? response.data : [];
    all.push(...rows);
    if (rows.length < FUNNELS_SUMMARY_PAGE_SIZE) break;
    offset += FUNNELS_SUMMARY_PAGE_SIZE;
  }
  return all;
};

// Candidatas de imágenes de un embudo (portada, galería del producto y páginas)
// para configurarlas en el chatbot. productId = product_ref del mapping.
export const getFunnelChatbotImages = async (websiteId: string, productId: string) => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(`/websites/${websiteId}/chatbot-images`, {
    params: { productId },
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getListOfFunnelsForStoreWizard = async () => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(`/websites/summary`, {
    params: {
      include_generation: false,
      include_sales: false,
      limit: 100,
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getListOfFiles = async () => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(`/websites`, {
    headers: {
      "Content-Type": "multipart/form-data",
      // "owner-id": userId,
    },
  });
  return response.data;
};

export const deleteWebsite = async (userId: string, websiteId: string) => {
  const response: AxiosResponse = await axiosInstanceWebsite.delete(`/websites/${websiteId}`, {
    headers: {
      "Content-Type": "multipart/form-data",
      // "owner-id": userId,
    },
  });
  return response.data;
};

export const postGenerateComplementaryProduct = async (
  data: postGenerateComplementaryProductInterface
): Promise<ProductRecommendation> => {
  const response: AxiosResponse = await axiosInstanceConversationalEngine.post(
    `/recommend-product`,
    data
  );
  return response.data;
};
